var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogoFooter = function SvgIconLogoFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M22.733.019A26 26 0 0 0 11.88 3.965l6.49 1.622z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m15.162 9.7 3.208-4.113-6.49-1.604z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M15.162 9.7 11.88 3.982l-1.338 6.638z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M11.88 3.983C8.69 6.03 5.995 8.76 3.94 11.95l6.6-1.346zM9.625 15.25l.916-4.629-6.6 1.346zM18.37 5.587l4.363 1.107V.019zM0 22.884h6.618l-1.081-4.757z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M9.625 15.25 3.94 11.967l1.595 6.528z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M3.942 11.968A26.1 26.1 0 0 0 0 22.883l5.537-4.389zM18.37 5.587l-3.208 4.094a19.35 19.35 0 0 1 7.572-3.006zM15.162 9.7l-4.602.921-.935 4.629c1.467-2.194 3.337-4.094 5.537-5.55M9.625 15.25l-4.07 3.227 1.081 4.388a19.3 19.3 0 0 1 2.989-7.615M0 28.987a26.4 26.4 0 0 0 3.923 10.917l1.614-6.528z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m9.606 36.603-4.07-3.227-1.613 6.528zM3.941 39.904a26.45 26.45 0 0 0 7.92 7.984l-1.338-6.638zM15.144 42.172l-4.602-.94 1.32 6.656zM5.537 33.376l1.081-4.389H0zM22.733 51.853v-6.657l-4.73 1.07z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m15.143 42.172-3.282 5.716 6.49-1.623zM11.861 47.888a26 26 0 0 0 10.872 3.965l-4.363-5.57zM5.537 33.376l4.07 3.227a19.6 19.6 0 0 1-2.988-7.616zM9.606 36.603l.917 4.628 4.602.94a20.1 20.1 0 0 1-5.519-5.568M15.144 42.172l3.208 4.093 4.382-1.07a19.9 19.9 0 0 1-7.59-3.023M28.802 51.853a26 26 0 0 0 10.853-3.946l-6.49-1.623zM36.373 42.172l-3.208 4.094 6.472 1.622z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m36.373 42.172 3.263 5.716 1.339-6.638zM39.637 47.888c3.19-2.047 5.885-4.776 7.938-7.966l-6.6 1.346zM41.91 36.622l-.935 4.628 6.6-1.328v-.018zM33.165 46.266l-4.363-1.07v6.657zM51.517 28.988h-6.619l1.082 4.757z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m41.91 36.621 5.665 3.283-1.595-6.528zM47.576 39.904a26.4 26.4 0 0 0 3.941-10.935l-5.537 4.389zM33.165 46.266l3.208-4.094a19.35 19.35 0 0 1-7.571 3.006zM36.373 42.19l4.602-.922.935-4.628a20.7 20.7 0 0 1-5.537 5.55"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m41.91 36.622 4.07-3.227-1.081-4.39a19.8 19.8 0 0 1-2.989 7.616M51.516 22.884a26.4 26.4 0 0 0-3.923-10.917l-1.614 6.528z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m41.91 15.268 4.07 3.227 1.614-6.528z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m41.91 15.268 5.683-3.3-6.618-1.328zM47.593 11.968a26.46 26.46 0 0 0-7.92-7.985l1.338 6.638zM36.373 9.7l4.602.94-1.32-6.657zM45.98 18.495l-1.082 4.389h6.619zM28.802.019v6.675l4.73-1.088z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m36.373 9.7 3.282-5.717-6.49 1.623z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M39.655 3.983A26 26 0 0 0 28.783.02l4.364 5.568zM45.98 18.495l-4.07-3.227a19.6 19.6 0 0 1 2.989 7.616zM41.91 15.268l-.917-4.628-4.601-.94a19.9 19.9 0 0 1 5.518 5.568M36.373 9.7l-3.208-4.094-4.363 1.088a19.35 19.35 0 0 1 7.571 3.005M25.759 10.068l-4.62 8.04h9.258zM30.397 18.108l-4.638 8.058h9.24zM34.998 26.166l-4.601 8.058h9.24zM21.139 34.224l4.62-8.058h-9.24z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M30.397 34.224 35 26.166h-9.24zM25.759 26.166l4.638-8.058h-9.258zM16.518 26.166l-4.62 8.058h9.24zM25.759 10.068l-4.62 8.04h9.258z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m30.397 18.108-4.638 8.058h9.24zM34.998 26.166l-4.601 8.058h9.24zM21.139 34.224l4.62-8.058h-9.24z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M30.397 34.224 35 26.166h-9.24zM25.759 26.166l4.638-8.058h-9.258zM16.518 26.166l-4.62 8.058h9.24zM9.606 36.603l.935 4.628-6.6-1.327z"
  })));
};
export default SvgIconLogoFooter;